export default __webpack_public_path__ + "static/media/appScreenMb2.79e6be2f.png";